import { render, staticRenderFns } from "./arReceivables.vue?vue&type=template&id=08673388"
import script from "./arReceivables.vue?vue&type=script&lang=js"
export * from "./arReceivables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports